import {Component} from "@angular/core";
import {SpecialSearchModel} from "../special-search.model";
import {SpecialEntityModel} from "../special-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-special-search-page",
    templateUrl: "./special-search-page.component.html",
    providers: [provideSearchModel(SpecialSearchModel), provideEntityModel(SpecialEntityModel)]
})
export class SpecialSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
